import { TbClockCancel, TbLoader } from "react-icons/tb";
import { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";

import { pricePublicContext } from "../../../context/PublicContext/PricePublicContext/PricePublicContext";

import PcListUi from "../../../helpers/PcListUi/PcListUi";
import { decodeJWT } from "../../../utils";
import { MdOutlineInventory } from "react-icons/md";
import { HiOutlineX } from "react-icons/hi";

const PcPriceView = () => {
  const userInfo = useSelector((state) => state.userInfo);
  const timerStatus = useSelector((state) => state.timerStatus);

  const token = localStorage.getItem("token");
  const roleName = decodeJWT(token)?.usertype;

  const {
    setIs_orderi,
    description,
    setDescription,
    setCustomeruser,
    setProduct_name,
    resultModal,
    setResultModal,
    orderModal,
    setOrderModal,
    data,
    setData,
    getItemsList,
    type,
    setType,
    stateWeight,
    setStateWeight,
    setBos,
    transactionId,
    statePrice,
    setStatePrice,
    stateTotal,
    setStateTotal,
    setCounter,
    handleGetItemsList,
    handlePostTransaction,
    handlePriceChange,
    handleWeightChange,
    handleTotalChange,
    addCommas,
    loading,
    setLoading,
    //* Timer Of Order
    isTimerOn,
    setIsTimerOn,
    handleStartTimer,
    //* Update Product
    buyTolerance,
    setBuyTolerance,
    sellTolerance,
    setSellTolerance,
    handleChangeBuyPrice,
    handleChangeSellPrice,
    handleUpdateProduct,
    //* Is Price Close
    handleChangeBuyClosePriceProduct,
    handleChangeSellClosePriceProduct,
    //* Is Orders Close
    isOrdersClose,
    handleGetOrdersStatus,
    //* Balance Modal
    balanceInfo,
    setBalanceInfo,
    productsBalance,
    handleGetProducts,
    //* Is Orderi Status
    isOrderiClose,
    setIsOrderiClose,
    handleGetOrderiStatus,
  } = useContext(pricePublicContext);

  //* Fetch Data
  const handleInitial = async () => {
    setCounter((prevCounter) => prevCounter + 1);
    await handleGetItemsList();
    handleGetOrderiStatus();
  };

  useEffect(() => {
    const fetchData = async () => {
      await handleInitial();
      setLoading(false);
    };
    fetchData();

    const interval = setInterval(handleInitial, 1000);
    return () => clearInterval(interval);
  }, []);

  //* Fetch Orders Status
  useEffect(() => {
    handleGetOrdersStatus();
  }, []);

  //* Fetch Products Balance
  useEffect(() => {
    if (!roleName || roleName !== "ADMIN") return;
    handleGetProducts();
  }, [roleName]);

  //* Table Title
  const tableTitle = [
    { id: 1, title: "#" },
    { id: 2, title: "نام محصول" },
    { id: 3, title: "خرید شما" },
    { id: 4, title: "فروش شما" },
    { id: 5, title: "آخرین آپدیت" },
  ];

  //* Loading
  if (loading) {
    return (
      <span
        className="mr-auto 2xl:w-[100%] xl:w-[95%] lg:w-[90%]
        py-3 absolute top-[50%] mt-10 text-slate-200 text-xl
        flex flex-col justify-center items-center"
      >
        <span>
          <TbLoader size={60} />
        </span>
        <p>لطفا صبر کنید</p>
      </span>
    );
  }

  return (
    <>
      <section>
        {isEmpty(getItemsList) ? (
          <>
            <span
              className="mr-auto w-full py-3 absolute top-[50%] mt-10
              text-slate-200 text-xl flex flex-col justify-center items-center"
            >
              <span>
                <TbClockCancel size={60} />
              </span>
              <p>سامانه بسته می باشد</p>
            </span>
          </>
        ) : (
          <>
            <div className="mt-8 w-full flex justify-end items-center relative">
              {/* Balance Icon */}
              {roleName === "ADMIN" && (
                <span className="absolute left-0 top-0 flex justify-end p-5 pt-0 w-full">
                  <MdOutlineInventory
                    size={30}
                    onClick={() => setBalanceInfo(true)}
                    className="cursor-pointer text-slate-200 hover:text-slate-400"
                  />
                </span>
              )}
              {/* Table */}
              <table className="w-full 2xl:w-[95%] xl:w-[93%] lg:w-[90%] mt-10">
                <thead className="text-sm font-medium text-slate-200 border-b-[1px] border-boxColor">
                  <tr>
                    {tableTitle.map((_item, index) => (
                      <th key={index} className="py-3 pr-3">
                        {_item?.title}
                      </th>
                    ))}
                  </tr>
                </thead>
                {/* Table Body */}
                <tbody className="text-lg divide-y divide-boxColor w-full">
                  {getItemsList.map(
                    (_item, index) =>
                      _item.periority === true && (
                        <PcListUi
                          key={_item.id || index}
                          index={index}
                          roleName={roleName}
                          isOrdersClose={isOrdersClose}
                          isOrderiClose={isOrderiClose}
                          setIsOrderiClose={setIsOrderiClose}
                          timerStatus={timerStatus}
                          _item={_item}
                          data={data}
                          setData={setData}
                          resultModal={resultModal}
                          setResultModal={setResultModal}
                          orderModal={orderModal}
                          setOrderModal={setOrderModal}
                          statePrice={statePrice}
                          setStatePrice={setStatePrice}
                          handlePriceChange={handlePriceChange}
                          stateWeight={stateWeight}
                          setStateWeight={setStateWeight}
                          handleWeightChange={handleWeightChange}
                          stateTotal={stateTotal}
                          setStateTotal={setStateTotal}
                          handleTotalChange={handleTotalChange}
                          description={description}
                          setDescription={setDescription}
                          addCommas={addCommas}
                          type={type}
                          setType={setType}
                          handlePostTransaction={handlePostTransaction}
                          setProduct_name={setProduct_name}
                          setCustomeruser={setCustomeruser}
                          userInfo={userInfo}
                          setBos={setBos}
                          setIs_orderi={setIs_orderi}
                          transactionId={transactionId}
                          isTimerOn={isTimerOn}
                          setIsTimerOn={setIsTimerOn}
                          handleStartTimer={handleStartTimer}
                          buyTolerance={buyTolerance}
                          setBuyTolerance={setBuyTolerance}
                          sellTolerance={sellTolerance}
                          setSellTolerance={setSellTolerance}
                          handleChangeBuyPrice={handleChangeBuyPrice}
                          handleChangeSellPrice={handleChangeSellPrice}
                          handleUpdateProduct={handleUpdateProduct}
                          handleChangeBuyClosePriceProduct={
                            handleChangeBuyClosePriceProduct
                          }
                          handleChangeSellClosePriceProduct={
                            handleChangeSellClosePriceProduct
                          }
                        />
                      )
                  )}
                </tbody>
                <tbody className="text-lg divide-y divide-boxColor w-full">
                  {getItemsList.map(
                    (_item, index) =>
                      _item.periority === false && (
                        <PcListUi
                          key={_item.id || index}
                          index={index}
                          roleName={roleName}
                          isOrdersClose={isOrdersClose}
                          isOrderiClose={isOrderiClose}
                          timerStatus={timerStatus}
                          _item={_item}
                          data={data}
                          setData={setData}
                          resultModal={resultModal}
                          setResultModal={setResultModal}
                          orderModal={orderModal}
                          setOrderModal={setOrderModal}
                          statePrice={statePrice}
                          setStatePrice={setStatePrice}
                          handlePriceChange={handlePriceChange}
                          stateWeight={stateWeight}
                          setStateWeight={setStateWeight}
                          handleWeightChange={handleWeightChange}
                          stateTotal={stateTotal}
                          setStateTotal={setStateTotal}
                          handleTotalChange={handleTotalChange}
                          description={description}
                          setDescription={setDescription}
                          addCommas={addCommas}
                          type={type}
                          setType={setType}
                          handlePostTransaction={handlePostTransaction}
                          setProduct_name={setProduct_name}
                          setCustomeruser={setCustomeruser}
                          userInfo={userInfo}
                          setBos={setBos}
                          setIs_orderi={setIs_orderi}
                          transactionId={transactionId}
                          isTimerOn={isTimerOn}
                          setIsTimerOn={setIsTimerOn}
                          handleStartTimer={handleStartTimer}
                          buyTolerance={buyTolerance}
                          setBuyTolerance={setBuyTolerance}
                          sellTolerance={sellTolerance}
                          setSellTolerance={setSellTolerance}
                          handleChangeBuyPrice={handleChangeBuyPrice}
                          handleChangeSellPrice={handleChangeSellPrice}
                          handleUpdateProduct={handleUpdateProduct}
                          handleChangeBuyClosePriceProduct={
                            handleChangeBuyClosePriceProduct
                          }
                          handleChangeSellClosePriceProduct={
                            handleChangeSellClosePriceProduct
                          }
                        />
                      )
                  )}
                </tbody>
              </table>
              {/* User Info Modal */}
              {balanceInfo && (
                <div
                  className="fixed bg-black bg-opacity-40 inset-0
                  w-full h-full z-50 flex items-center justify-center
                  animate__animated animate__fadeIn animate__fast"
                >
                  <div
                    className="flex flex-col absolute lg:top-20 top-10
                    w-11/12 sm:w-5/6 lg:w-12/12 max-w-2xl mx-auto 
                    rounded-lg border-2 border-modalColor"
                  >
                    {/* Title - Close Icon */}
                    <div className="flex flex-row justify-between p-5 bg-modalColor">
                      {/* Close Icon */}
                      <span>
                        <HiOutlineX
                          size={25}
                          onClick={() => setBalanceInfo(false)}
                          className="text-gray-400 cursor-pointer"
                        />
                      </span>
                      {/* Title */}
                      <span className="flex justify-center items-center w-full">
                        <p className="flex font-medium lg:text-base text-sm text-gray-300">
                          موجودی محصولات
                        </p>
                      </span>
                    </div>
                    {/* Divider */}
                    <span className="border-b-2 border-headerLineModal" />
                    {/* Table */}
                    <div className="w-full h-full pt-5 bg-modalColor">
                      <div className="w-full h-96 overflow-y-auto text-sm font-medium text-slate-200">
                        <table className="w-full h-full">
                          <thead className="border-b-[1px] border-headerLineModal">
                            <tr>
                              <th className="py-4">نام محصول</th>
                              <th className="py-4">موجودی</th>
                            </tr>
                          </thead>
                          <tbody className="w-full">
                            {productsBalance.map((_item, index) => (
                              <tr
                                key={index}
                                className="hover:bg-boxColor w-full h-10"
                              >
                                <td className="py-4">
                                  <span className="flex justify-center items-center">
                                    {_item?.name}
                                  </span>
                                </td>
                                <td className="py-4">
                                  <span className="flex justify-center items-center">
                                    {_item?.balance}
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {/* Button */}
                      <div className="flex items-center justify-center p-5 w-full">
                        <button
                          type="button"
                          onClick={() => setBalanceInfo(false)}
                          className="px-4 py-1.5 text-white text-sm font-medium bg-red-500 hover:bg-red-600 rounded"
                        >
                          بستن
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </section>
    </>
  );
};

export default PcPriceView;
